/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, DocumentAdminControllerPreviewOrphanedDocumentReconciliation400, DocumentAdminControllerPreviewOrphanedDocumentReconciliation401, DocumentAdminControllerPreviewOrphanedDocumentReconciliation403, DocumentAdminControllerPreviewOrphanedDocumentReconciliation404 } from "../../models/documentAdminController/DocumentAdminControllerPreviewOrphanedDocumentReconciliation";

function getDocumentAdminControllerPreviewOrphanedDocumentReconciliationUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/orphaned-document-reconciliations/preview` as const }  
  return res
}

/**
 * @description Admin/service-account endpoint. Read-only: detects documents still ACTIVE whose source file has been soft-deleted and returns them without changing any data. Use this to see what a reconciliation would do before approving it, and again afterwards to verify.
 * @summary Preview orphaned ACTIVE documents whose source file is deleted
 * {@link /api/v1/documents/orphaned-document-reconciliations/preview}
 */
export async function documentAdminControllerPreviewOrphanedDocumentReconciliation(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentAdminControllerPreviewOrphanedDocumentReconciliationQueryResponse, ResponseErrorConfig<DocumentAdminControllerPreviewOrphanedDocumentReconciliation400 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation401 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation403 | DocumentAdminControllerPreviewOrphanedDocumentReconciliation404>, unknown>({ method : "GET", url : getDocumentAdminControllerPreviewOrphanedDocumentReconciliationUrl().url.toString(), ... requestConfig })  
  return res.data
}